var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ReleaseCom from "../../components/releaseCom.vue";
import DialogImportPermission from './components/DialogImportPermission.vue';
import _ from "lodash";
import UserService from '../../api/UserService';
function getFlatList(list) {
    if (list === void 0) { list = []; }
    var result = [];
    if (Array.isArray(list) && list.length) {
        list.forEach(function (item) {
            result.push(item);
            if (Array.isArray(item.children) && item.children.length) {
                result.push.apply(result, getFlatList(item.children));
            }
        });
    }
    return result;
}
var Auth = (function (_super) {
    __extends(Auth, _super);
    function Auth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = 'func';
        _this.funcTree = [];
        _this.funcDataTree = [];
        _this.depotDataTree = [];
        _this.defaultProps = {
            children: 'children',
            label: 'power_cn'
        };
        _this.funcChildrenKeys = [];
        _this.dataChildrenKeys = [];
        _this.canSetCheckedValue = false;
        _this.checkedAllFunc = false;
        _this.checkedAllData = false;
        _this.checkedAllDepot = false;
        _this.indeterminateFunc = false;
        _this.indeterminateData = false;
        _this.indeterminateDepot = false;
        _this.debounceFunc = null;
        _this.debounceFuncData = null;
        _this.debounceFuncDepot = null;
        _this.keyword = '';
        _this.rowData = null;
        return _this;
    }
    Auth.prototype.keywordChange = function (val) {
        console.log('keywordChange>>>', val)(this.$refs.funcDataTree) && this.$refs.funcDataTree.filter(val);
    };
    Auth.prototype.created = function () {
        this.service = UserService.getInstance();
        this.debounceFunc = _.debounce(this.computedCheckAll.bind(this, 'func'), 300);
        this.debounceFuncDepot = _.debounce(this.computedCheckAll.bind(this, 'depot'), 300);
        this.debounceFuncData = _.debounce(this.computedCheckAll.bind(this, 'data'), 300);
    };
    Auth.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.power_cn.indexOf(value) !== -1;
    };
    Auth.prototype.computedCheckAll = function (type) {
        var _a = type === 'data' ?
            ['funcDataTree', 'checkedAllData', 'indeterminateData', 'flatFuncDataList'] :
            (type === 'func' ? ['funcTree', 'checkedAllFunc', 'indeterminateFunc', 'flatFuncList'] :
                ['depotDataTree', 'checkedAllDepot', 'indeterminateDepot', 'flatDepotList']), ref = _a[0], checkAllField = _a[1], indeterminateField = _a[2], flatListField = _a[3];
        var checkedIds = this.$refs[ref] && this.$refs[ref].getCheckedKeys();
        var flatList = this[flatListField];
        this[checkAllField] = checkedIds.length === flatList.length;
        this[indeterminateField] = checkedIds.length > 0 && checkedIds.length < flatList.length;
    };
    Auth.prototype.handleCheckAll = function (type) {
        var _a = type === 'data' ?
            ['funcDataTree', 'checkedAllData', 'indeterminateData', 'flatFuncDataList'] :
            (type === 'func' ? ['funcTree', 'checkedAllFunc', 'indeterminateFunc', 'flatFuncList'] :
                ['depotDataTree', 'checkedAllDepot', 'indeterminateDepot', 'flatDepotList']), ref = _a[0], checkAllField = _a[1], indeterminateField = _a[2], flatListField = _a[3];
        this[indeterminateField] = false;
        this[checkAllField] = !this[checkAllField];
        var checkedKeys = [];
        if (this[checkAllField]) {
            checkedKeys = this[flatListField].map(function (item) { return item.power_id; });
        }
        this.$refs[ref] && this.$refs[ref].setCheckedKeys(checkedKeys);
    };
    Auth.prototype.close = function () {
        this.$refs.release && this.$refs.release.hide();
    };
    Auth.prototype.exportIn = function () {
        this.$refs.importPermission.showImportModal();
    };
    Auth.prototype.funcCheckChange = function () {
        this.debounceFunc();
    };
    Auth.prototype.funcDataCheckChange = function () {
        this.debounceFuncData();
    };
    Auth.prototype.getCheckeChangedParentsKey = function (current, arr) {
        var children = current.children;
        var childHasChecked = false;
        if (!children) {
            if (arr.indexOf(current.power_id) > -1) {
                return true;
            }
            return false;
        }
        for (var i = 0; i < children.length; i++) {
            if (children[i].children && children[i].children.length) {
                var tempChecked = this.getCheckeChangedParentsKey(children[i], arr);
                childHasChecked = childHasChecked || tempChecked;
            }
            else {
                if (arr.indexOf(children[i].power_id) > -1) {
                    childHasChecked = true;
                    break;
                }
            }
        }
        if (childHasChecked && arr.indexOf(current.power_id) === -1) {
            arr.push(current.power_id);
        }
        return childHasChecked;
    };
    Auth.prototype.nodeClick = function (data, node, target) {
    };
    Auth.prototype.childCheck = function (data, target) {
    };
    Auth.prototype.save = function () {
        var _this = this;
        console.log('save>>>');
        if (this.isFunctionAuth) {
            var account_power_1 = this.$refs.funcTree.getCheckedKeys();
            var accpunt_power_half = this.$refs.funcTree.getHalfCheckedKeys();
            var all_account_power = account_power_1.concat(accpunt_power_half);
            var params = {
                supplier_role_id: this.rowData.supplier_role_id ? this.rowData.supplier_role_id : null,
                account_power: all_account_power.join(","),
            };
            this.funcTree.forEach(function (item) { return _this.getCheckeChangedParentsKey(item, account_power_1); });
            this.service.setUserAuth(params).then(function (res) {
                _this.$emit('refresh');
                _this.$message.success(res.data.msg || "设置成功");
                window._czc.push(["_trackEvent", '用户列表', '分配权限']);
            }).catch(function (err) {
                _this.$message.error(err.message || '保存失败');
            });
        }
        if (this.isDataAuth && 1 == this.businessDataPowerUse) {
            var data_power_1 = this.$refs.funcDataTree.getCheckedKeys();
            var data_half_power = this.$refs.funcDataTree.getHalfCheckedKeys();
            var all_data_power = data_power_1.concat(data_half_power);
            var params = {
                account_id: this.rowData.account_id ? this.rowData.account_id : null,
                data_power: all_data_power.join(",")
            };
            this.funcDataTree.forEach(function (item) { return _this.getCheckeChangedParentsKey(item, data_power_1); });
            this.service.setDataAuth(params).then(function (res) {
                _this.close();
                _this.$emit('refresh');
                _this.$message.success(res.data.msg || "设置成功");
                window._czc.push(["_trackEvent", '用户列表', '分配权限']);
            }).catch(function (err) {
                _this.$message.error(err.message || '保存失败');
            });
        }
        if (this.isDepotAuth) {
            var depot_data_power = this.$refs.depotDataTree.getCheckedKeys();
            var depot_data_half_power = this.$refs.depotDataTree.getHalfCheckedKeys();
            var depot_all_data_power = depot_data_power.concat(depot_data_half_power);
            var params = {
                account_id: this.rowData.account_id ? this.rowData.account_id : null,
                depot_data_power: depot_all_data_power.join(","),
                type: 2,
            };
            this.service.setDataAuth(params).then(function (res) {
                _this.close();
                _this.$emit('refresh');
                _this.$message.success(res.data.msg || "设置成功");
                window._czc.push(["_trackEvent", '用户列表', '分配权限']);
            }).catch(function (err) {
                _this.$message.error(err.message || '保存失败');
            });
        }
    };
    Auth.prototype.showRelease = function () {
        var _this = this;
        this.rowData = JSON.parse(sessionStorage.getItem("clickRoleId"));
        this.$refs.release.show({ hasMask: true });
        this.getTreeData();
        setTimeout(function () {
            _this.$refs.tab.setCurrentName(_this.isFunctionAuth ? "func" : (_this.isDataAuth ? "data" : "depotData"));
            _this.getFuncAuthList();
        }, 300);
    };
    Auth.prototype.getTreeData = function () {
        var _this = this;
        if (this.isFunctionAuth) {
            console.log(this.rowData, "this.rowData.");
            this.service.getAuthTree({
                supplier_role_id: this.rowData.supplier_role_id,
            }).then(function (res) {
                _this.funcTree = res.data.data;
                console.log(_this.funcTree);
            }).catch(function (err) {
                _this.$message.error(err.message || '获取权限失败');
            });
        }
        if (this.isDataAuth) {
            this.service.getDataAuthTree().then(function (res) {
                _this.funcDataTree = res.data.data;
            }).catch(function (err) {
                _this.$message.error(err.message || '获取权限失败');
            });
            this.service.getDepotAuthTree({ type: 2 }).then(function (res) {
                _this.depotDataTree = res.data.data;
            }).catch(function (err) {
                _this.$message.error(err.message || '获取权限失败');
            });
        }
        if (this.isDepotAuth) {
            this.service.getDepotAuthTree({ type: 2 }).then(function (res) {
                _this.depotDataTree = res.data.data;
            }).catch(function (err) {
                _this.$message.error(err.message || '获取权限失败');
            });
        }
    };
    Auth.prototype.addVirtualData = function () {
        var _this = this;
        console.log(this.funcDataTree);
        _.forEach(this.funcDataTree, function (item) {
            if (item.children && item.children.length) {
                var _loop_1 = function (i) {
                    var arr = [{
                            power_id: 9999999,
                            power_cn: "暂无门店",
                            disabled: true
                        }];
                    _this.$nextTick(function () {
                        _this.$refs.funcDataTree.updateKeyChildren(item.children[i].power_id, arr);
                    });
                };
                for (var i = 0; i < item.children.length; i++) {
                    _loop_1(i);
                }
            }
        });
    };
    Auth.prototype.getFuncAuthList = function () {
        var _this = this;
        if (this.isFunctionAuth) {
            this.service.getUserAuth({ supplier_role_id: this.rowData.supplier_role_id }).then(function (res) {
                res.data.data = res.data.data.join(",");
                var auth = res.data.data || '';
                var funcChildrenKeys = [];
                _.forEach(_this.funcTree, function (item) {
                    _this.getLeafKeys(item, funcChildrenKeys);
                });
                var roleAuthKeys = auth.split(',').filter(function (item) { return funcChildrenKeys.indexOf(item) > -1; });
                _this.$refs.funcTree && _this.$refs.funcTree.setCheckedKeys(roleAuthKeys);
                _this.$nextTick(function () { return _this.canSetCheckedValue = true; });
            }).catch(function (err) {
                _this.$message.error(err.message || '获取权限失败');
            });
        }
        if (this.isDataAuth) {
            this.service.getUserDataAuth({ account_id: this.rowData.account_id }).then(function (res) {
                var auth = res.data.data || '';
                var funcChildrenKeys = [];
                _.forEach(_this.funcDataTree, function (item) {
                    _this.getLeafKeys(item, funcChildrenKeys);
                });
                var roleAuthKeys = auth.split(',').filter(function (item) { return funcChildrenKeys.indexOf(item) > -1; });
                _this.$refs.funcDataTree && _this.$refs.funcDataTree.setCheckedKeys(roleAuthKeys);
                _this.$nextTick(function () { return _this.canSetCheckedValue = true; });
            }).catch(function (err) {
                _this.$message.error(err.message || '获取权限失败');
            });
        }
        if (this.isDepotAuth) {
            this.service.getUserDataAuth({ account_id: this.rowData.account_id, type: 2 }).then(function (res) {
                var auth = res.data.data || '';
                var funcChildrenKeys = [];
                _.forEach(_this.depotDataTree, function (item) {
                    _this.getLeafKeys(item, funcChildrenKeys);
                });
                var roleAuthKeys = auth.split(',').filter(function (item) { return funcChildrenKeys.indexOf(item) > -1; });
                _this.$refs.depotDataTree && _this.$refs.depotDataTree.setCheckedKeys(roleAuthKeys);
                _this.$nextTick(function () { return _this.canSetCheckedValue = true; });
            }).catch(function (err) {
                _this.$message.error(err.message || '获取权限失败');
            });
        }
    };
    Auth.prototype.getLeafKeys = function (node, arr) {
        var _this = this;
        if (arr === void 0) { arr = []; }
        if (!node.children || !node.children.length) {
            arr.push(node.power_id.toString());
        }
        else {
            node.children.forEach(function (item) { return _this.getLeafKeys(item, arr); });
        }
        return arr;
    };
    Auth.prototype.getChildrenKeys = function (node, arr) {
        var _this = this;
        if (arr === void 0) { arr = []; }
        arr.push(node.key);
        var children = node.childNodes;
        if (children && children.length) {
            children.forEach(function (item) { return _this.getChildrenKeys(item, arr); });
        }
        return arr;
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], Auth.prototype, "isFunctionAuth", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], Auth.prototype, "isDataAuth", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 1
        })
    ], Auth.prototype, "businessDataPowerUse", void 0);
    __decorate([
        Watch("keyword")
    ], Auth.prototype, "keywordChange", null);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], Auth.prototype, "isDepotAuth", void 0);
    Auth = __decorate([
        Component({
            components: {
                'release-com': ReleaseCom,
                'import-permission': DialogImportPermission
            },
            computed: {
                flatFuncList: function () {
                    var funcTree = this.funcTree || [];
                    var flatList = getFlatList(funcTree);
                    return flatList || [];
                },
                flatFuncDataList: function () {
                    var funcDataTree = this.funcDataTree || [];
                    var flatList = getFlatList(funcDataTree);
                    return flatList || [];
                },
                flatDepotList: function () {
                    var depotDataTree = this.depotDataTree || [];
                    var flatList = getFlatList(depotDataTree);
                    return flatList || [];
                },
                uploadProps: function () {
                    var uploadAuthMap = {
                        data: {
                            title: '数据权限导入',
                            downloadUrl: '/supplierclientapi/supplierpower/download_business_data_power_template',
                            importUrl: '/supplierclientapi/supplierpower/import_business_data_power'
                        },
                        depotData: {
                            title: '仓库数据权限导入',
                            downloadUrl: '/supplierclientapi/supplierpower/download_depot_data_power_template',
                            importUrl: '/supplierclientapi/supplierpower/import_depot_data_power'
                        },
                    };
                    var name = this.activeName;
                    if (!['data', 'depotData'].includes(this.activeName)) {
                        name = 'data';
                    }
                    return uploadAuthMap[name];
                },
            }
        })
    ], Auth);
    return Auth;
}(Vue));
export default Auth;
